import React from 'react';
import PropTypes from 'prop-types';
import Penguin from '../characters/Penguin';
import Nutria from '../characters/Nutria';
import {Container} from '@inlet/react-pixi';
import Construction from '../characters/Construction';
import Background from '../Background';
import gamesBackground from '../../resource/ui/gamesBackground2.jpg';
import Texto from "../Texto";
import {connect} from 'react-redux';
import Cinta from '../characters/Cinta';
import {isBrowser, isMobile, isTablet} from "react-device-detect";

import * as PIXI from "pixi.js";

import construction_png from '../../resource/construction/construccion_tex.png';
import penguin_png from '../../resource/penguin/penguin_tex.png';
import nutria_png from '../../resource/nutria/nutria_tex.png';
import {bindActionCreators} from "redux";
import * as actions from "../../actions/transitionActions";
import transitionController from "../../transitionController";
import {clearStage, loadPageResources} from "../../Helpers";

class Games extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            characters: [],
        }

        this._resources = [];
        this.mountTimeOut = null;

        this.app = this.props.app;
        this.loadCharacters = this.loadCharacters.bind(this);
        this.loadResources = this.loadResources.bind(this);

        const resources = []
        resources.push(gamesBackground, nutria_png, construction_png, penguin_png, Cinta);

        this.loadResources(resources)
    }

    componentDidMount() {

    }

    loadResources(unprocessedResources) {
        loadPageResources(unprocessedResources, (loader, resources) => {
            this._resources = resources;
            this.loadCharacters();

            transitionController.reveal().then(() => {
                this.props.actions.hideTransition();
            });
        });
    };

    loadCharacters() {
        let textXPos = null;
        let fontSize = null;

        switch(this.props.options.lang){
            case 'es':
                textXPos = 690;
                fontSize = 60;
                break;
            case 'pt':
                textXPos = 720;
                fontSize = 60;
                break;

            default:

                textXPos = 680;
                fontSize = 50;

        }

        // Clear previous stage content before loading new characters
        let characterPos = {
            Nutria: {x: 400, y: 750},
            Penguin: {x: 1700, y: 900},
        }
        if (isMobile) {
            characterPos = {
                Nutria: {x: 400, y: 750},
                Penguin: {x: 1750, y: 900},
            }
        }
        if (isTablet) {
            characterPos = {
                Nutria: {x: 400, y: 750},
                Penguin: {x: 1650, y: 900},
            }
        }
        if (isBrowser) {
            characterPos = {
                Nutria: {x: 400, y: 750},
                Penguin: {x: 1660, y: 800},
            }
        }

        this.setState({
            characters: [
                {component: Background, x: 0, y: 0, scale: 1, timeout: 0, background: gamesBackground},
                {component: Construction, x: 1040, y: 450, scale: 1, timeout: 0, background: ''},
                {
                    component: Texto,
                    x: textXPos - 5,
                    y: 423,
                    color: 0x0D3157,
                    fontSize:fontSize,
                    scale: 1,
                    timeout: 0,
                    background: this.props.dictionary[this.props.options.lang].under_construction
                },
                {
                    component: Texto,
                    x: textXPos,
                    y: 418,
                    color: 0xE3E3E3,
                    fontSize:fontSize,
                    scale: 1,
                    timeout: 0,
                    background: this.props.dictionary[this.props.options.lang].under_construction
                },
                {component: Cinta, x: 960, y: 725, scale: .7, timeout: 0, background: ''},
                {
                    component: Nutria,
                    x: characterPos.Nutria.x,
                    y: characterPos.Nutria.y,
                    scale: .40,
                    timeout: 0,
                    background: ''
                },
                {
                    component: Penguin,
                    x: characterPos.Penguin.x,
                    y: characterPos.Penguin.y,
                    scale: .8,
                    timeout: 0,
                    background: ''
                },
            ]
        })

    }

    componentWillUnmount() {
        clearStage(this.props.app);

        if(this.mountTimeOut){
            clearTimeout(this.mountTimeOut);
        }

    }

    shouldComponentUpdate(nextProps, nextState) {
        // Only re-render if characters array has changed
        if (this.state.characters.length !== nextState.characters.length) {
            return true;
        }

        // Check if any character properties have changed
        for (let i = 0; i < this.state.characters.length; i++) {
            const currentChar = this.state.characters[i];
            const nextChar = nextState.characters[i];

            if (currentChar.x !== nextChar.x ||
                currentChar.y !== nextChar.y ||
                currentChar.scale !== nextChar.scale ||
                currentChar.timeout !== nextChar.timeout ||
                currentChar.background !== nextChar.background ||
                currentChar.color !== nextChar.color ||
                currentChar.fontSize !== nextChar.fontSize) {
                return true;
            }
        }

        return false;
    }

    render() {

        return (

            <Container>
                {this.state.characters.map((character, index) => {
                    const TagName = character.component;
                    // Create unique keys by combining component name with background or position info
                    let keyName;
                    if (character.background) {
                        // For backgrounds, use the background filename to distinguish them
                        const backgroundName = character.background.split('/').pop().split('.')[0];
                        keyName = `${TagName.name}-${backgroundName}`;
                    } else {
                        // For other components, use component name and index
                        keyName = `${TagName.name}-${index}`;
                    }
                    return <TagName x={character.x} key={keyName} y={character.y} scale={character.scale} color={character.color} fontSize={character.fontSize} timeout={character.timeout}
                                    background={character.background} app={this.app} resources={this._resources}/>
                })
                }

            </Container>

        )
    }
}

Games.propTypes = {
    options: PropTypes.object.isRequired,
    dictionary: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
    app: PropTypes.object.isRequired,
    transition: PropTypes.bool.isRequired
}

const mapStateToProps = (state, ownProps) => {

    console.log(state.options);
    return {
        options: state.options,
        dictionary: state.dictionary,
        app: ownProps.app,
        transition: state.transition

    }
}

const mapDispatchToProps = (dispatch) => {

    return {
        actions: bindActionCreators({...actions}, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Games)



// WEBPACK FOOTER //
// ./src/components/pages/Games.js